export default __webpack_public_path__ + "static/media/02.3a4526c2.jpg";